// extracted by mini-css-extract-plugin
export default {"closer":"close-button_closer__0+QQG"};